import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import { CodebaseAskClient, codebaseAskApiRef } from './components/askAi/api';
import { HomeContentClient, homeContentApiRef } from './components/home/api';
import {
  GithubReleasesClient,
  releasesApiRef,
} from './components/releases/api';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: homeContentApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new HomeContentClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: releasesApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new GithubReleasesClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: codebaseAskApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
      microsoftAuthApi: microsoftAuthApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, fetchApi, microsoftAuthApi, configApi }) =>
      new CodebaseAskClient({
        discoveryApi,
        fetchApi,
        microsoftAuthApi,
        codebaseAudience: configApi.getOptionalString(
          'app.askAi.codebaseAudience',
        ),
      }),
  }),
];
